import { put, select, takeEvery } from 'redux-saga/effects'

import { NeumaticoResult } from '../../../../common/api/search'
import { catalogoListOkAction } from '../../../../shared/catalogo/store/list/catalogoListActions'
import * as CatalogoListAction from '../../../../shared/catalogo/store/list/catalogoListActions'
import { EnumFilter } from '../../../../shared/catalogo/type/filter'
import { selectMedidas } from '../../Buscador/SeleccionMedidas/Infrastructure/store/medidasSelectors'
import { isLegacyTemporadaLocked } from '../../../../common/components/FunnelSelector/hooks/useSyncedMedidasSelectorFields'
import {
  setEstacionAutoAjustada,
  setEstacionSeleccionada,
} from '../../Buscador/SeleccionMedidas/Infrastructure/store/medidasSlice'
import { NeumaticosFilters } from '../api/neumaticosFiltro'
import {
  resolveAvailableTemporadas,
  shouldAutoAdjustTemporada,
} from './temporadaCatalogUtils'

function* handleNeumaticosCatalogOk(
  action: ReturnType<typeof catalogoListOkAction>
) {
  const { catalogKey } = action.meta
  if (catalogKey !== 'neumaticos') return

  const medidas = yield select(selectMedidas)
  const legacyTemporadaLocked = yield select(isLegacyTemporadaLocked)
  if (legacyTemporadaLocked) return
  if (medidas.estacionSeleccionadaPorUsuario) return
  if (medidas.estacionAutoAjustada) return

  const products = (action.payload.data?.products ?? []) as NeumaticoResult[]
  const availableFilters = action.payload.data?.availableFilters as
    | NeumaticosFilters
    | undefined
  const estacionFilter = availableFilters?.estacion as EnumFilter | undefined

  const available = resolveAvailableTemporadas(products, estacionFilter)
  const nextTemporada = shouldAutoAdjustTemporada(
    medidas.selectedEstacion,
    available,
    products
  )

  if (!nextTemporada || nextTemporada === medidas.selectedEstacion) return

  yield put(setEstacionSeleccionada(nextTemporada))
  yield put(setEstacionAutoAjustada(true))
}

export function* neumaticosCatalogPostSaga() {
  yield takeEvery(
    CatalogoListAction.CATALOGO_LIST_OK,
    handleNeumaticosCatalogOk
  )
}
